import { z } from 'zod';

import { InsuranceType } from '@/utils/constants.js';

const appointmentSlotSchema = z.object({
    step_order: z.number().int().nonnegative(),
    calendar_id: z.string().min(1),
    start_date: z.iso.datetime(),
    end_date: z.iso.datetime(),
});

/** Request body for booking a chain collection; rejects duplicate step orders and non-positive slot windows. */
export const bookCollectionRequestSchema = z
    .object({
        location_key: z.string().min(1),
        chain_configuration_id: z.uuid(),
        insurance_type: z.enum(InsuranceType),
        is_new: z.boolean(),
        info: z.string().optional(),
        appointment_slots: z.array(appointmentSlotSchema).min(1),
    })
    .superRefine((request, ctx) => {
        const stepOrders = request.appointment_slots.map((slot) => slot.step_order);
        if (new Set(stepOrders).size !== stepOrders.length) {
            ctx.addIssue({
                code: 'custom',
                path: ['appointment_slots'],
                message: 'appointment_slots step_order values must be unique',
            });
        }
    })
    .superRefine((request, ctx) => {
        request.appointment_slots.forEach((slot, index) => {
            if (new Date(slot.end_date).getTime() <= new Date(slot.start_date).getTime()) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['appointment_slots', index, 'end_date'],
                    message: 'each slot end_date must be after start_date',
                });
            }
        });
    });

export type BookCollectionRequest = z.infer<typeof bookCollectionRequestSchema>;
